import {BrandThemeName} from '@daedalus/core/src/brand/types'

import {theme as flighthub} from './flighthub'
import {theme as goseek} from './goseek'
import {theme as justfly} from './justfly'
import {theme as kayak} from './kayak'
import {theme as kiwi} from './kiwi'
import {theme as vio} from './vio'

export enum ThemeNames {
  checkfelix = 'checkfelix',
  flighthub = 'flighthub',
  goseek = 'goseek',
  hotelscombined = 'hotelscombined',
  justfly = 'justfly',
  kayak = 'kayak',
  kiwi = 'kiwi',
  momondo = 'momondo',
  vio = 'vio'
}

type ThemeMap = Record<ThemeNames, any>

const themeMap: ThemeMap = {
  checkfelix: kayak,
  flighthub: flighthub,
  goseek: goseek,
  hotelscombined: kayak,
  justfly: justfly,
  kayak: kayak,
  kiwi: kiwi,
  momondo: kayak,
  vio: vio
}

export const getTheme = (themeName: BrandThemeName = ThemeNames.vio) =>
  themeMap[themeName] || vio
